var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"layout-oneside",attrs:{"id":"inspire"}},[_c('v-main',[_c('v-container',{staticClass:"authContent fill-height py-0",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('GlobalSnackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }